import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.scout-report-point-issue-form', () => {
  import('./internal/scout-report-point-issue-form').then(({ default: Component }) => Component());
});
